let directive = {
    bind: function(el, binding, vnode) {
        el.clickOutsideEvent = function(event) {
            const exceptionClasses = ['el-popper']
            // here I check that click was outside the el and his childrens
            if (!(el == event.target || el.contains(event.target)) && !(exceptionClasses.every(c => event.target.classList.contains(c)) || exceptionClasses.every(c => event.target.closest(`.${c}`)))) {
                // and if it did, call method provided in attribute value
                if(vnode.context[binding.expression]) vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('mousedown', el.clickOutsideEvent);
        document.body.addEventListener('touchstart', el.clickOutsideEvent);
    },
    unbind: function(el) {
        document.body.removeEventListener('mousedown', el.clickOutsideEvent);
        document.body.removeEventListener('touchstart', el.clickOutsideEvent);
    },
};

export default directive;
